module.exports = __webpack_public_path__ + "static/media/4@3x.39ea8493.png";